/* =========================================================================
   SARTE Leather — Motion layer v2 (JS)
   Button ripple + ink origin + magnetic pull + label swap, page-transition
   curtain, kicker line draw, product-card tilt. Reads flags from
   body[data-sarte-motion]. Re-initialises on Theme Editor section load.
   ========================================================================= */
(function () {
  'use strict';
  var d = document, w = window, b = d.body;
  var reduced = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = (w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches) || (!('ontouchstart' in w) && !(navigator.maxTouchPoints > 0));
  var cfg = {};
  try { cfg = JSON.parse(b.getAttribute('data-sarte-motion') || '{}'); } catch (e) { cfg = {}; }
  var motionOn = cfg.enabled !== false && !reduced;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function once(el, key) { key = 'sarteM' + key; if (el.dataset[key]) return true; el.dataset[key] = '1'; return false; }
  var BTN = '.sarte-btn, .btn, .quick-add-btn, .sarte-icon-btn';

  /* ---------- Ripple + ink origin ---------- */
  function initButtons(scope) {
    $$(BTN, scope).forEach(function (btn) {
      if (once(btn, 'Btn')) return;
      if (cfg.ink) {
        btn.addEventListener('pointerenter', function (e) {
          var r = btn.getBoundingClientRect();
          btn.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          btn.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      }
      if (cfg.ripple && motionOn) {
        btn.addEventListener('pointerdown', function (e) {
          if (e.button && e.button !== 0) return;
          var r = btn.getBoundingClientRect();
          var size = Math.max(r.width, r.height) * 2.2;
          var rip = d.createElement('span');
          var light = isLightBg(btn);
          rip.className = 'sarte-ripple' + (light ? ' sarte-ripple--dark' : '');
          rip.style.width = rip.style.height = size + 'px';
          rip.style.left = (e.clientX - r.left) + 'px';
          rip.style.top = (e.clientY - r.top) + 'px';
          if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
          if (getComputedStyle(btn).overflow !== 'hidden') btn.style.overflow = 'hidden';
          btn.appendChild(rip);
          setTimeout(function () { rip.remove(); }, 750);
        });
      }
    });
  }
  function isLightBg(el) {
    var c = getComputedStyle(el).backgroundColor.match(/\d+(\.\d+)?/g);
    if (!c || c.length < 3) return false;
    if (c[3] !== undefined && parseFloat(c[3]) < .3) return false;
    return (c[0] * 299 + c[1] * 587 + c[2] * 114) / 1000 > 160;
  }

  /* ---------- Label swap (duplicate text for the roll effect) ---------- */
  function initSwap(scope) {
    if (cfg.style !== 'swap') return;
    $$('.sarte-btn > span:first-child', scope).forEach(function (span) {
      if (once(span, 'Swap')) return;
      if (span.children.length || !span.textContent.trim()) return;
      var t = span.textContent.trim();
      span.className += ' sarte-swap';
      span.innerHTML = '<i>' + esc(t) + '</i><i aria-hidden="true">' + esc(t) + '</i>';
    });
  }
  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Magnetic pull ---------- */
  function initMagnetic(scope) {
    if (!cfg.magnetic || !fine || !motionOn) return;
    $$('.sarte-btn, .sarte-icon-btn, .sarte-totop', scope).forEach(function (el) {
      if (once(el, 'Mag')) return;
      if (el.classList.contains('sarte-btn--full')) return;
      el.classList.add('sarte-magnet');
      var strength = el.classList.contains('sarte-btn') ? .22 : .35;
      var maxPx = el.classList.contains('sarte-btn') ? 10 : 8;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) * strength;
        var dy = (e.clientY - (r.top + r.height / 2)) * strength;
        dx = Math.max(-maxPx, Math.min(maxPx, dx)); dy = Math.max(-maxPx, Math.min(maxPx, dy));
        el.classList.add('is-magnet');
        var tf = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)';
        el.style.setProperty('--mag', tf);
        el.style.transform = tf;
      });
      el.addEventListener('pointerleave', function () {
        el.classList.remove('is-magnet');
        el.style.removeProperty('--mag');
        el.style.transform = '';
      });
    });
  }

  /* ---------- Kicker line draw ---------- */
  function initKickers(scope) {
    var els = $$('.sarte-kicker', scope).filter(function (k) { return !once(k, 'Kick'); });
    if (!els.length) return;
    if (!motionOn || !('IntersectionObserver' in w)) { els.forEach(function (k) { k.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: .2, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (k) { io.observe(k); });
  }

  /* ---------- Product-card tilt ---------- */
  function initCardTilt(scope) {
    if (cfg.card !== 'tilt' || !fine || !motionOn) return;
    $$('.product-card', scope).forEach(function (card) {
      if (once(card, 'Tilt')) return;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        card.classList.add('is-tilting');
        card.style.transform = 'perspective(1000px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 5).toFixed(2) + 'deg) translateY(-4px)';
      });
      card.addEventListener('pointerleave', function () {
        card.classList.remove('is-tilting');
        card.style.transform = '';
      });
    });
  }

  /* ---------- Page transitions ---------- */
  function initPageTransitions() {
    if (!cfg.pt || !motionOn) return;
    var html = d.documentElement;
    var pt = $('[data-sarte-pt]');
    try { sessionStorage.removeItem('sarte_pt'); } catch (e) {}
    if ((w.Shopify && w.Shopify.designMode) || !pt) { html.classList.remove('sarte-pt-pending'); return; } // never inside the Theme Editor
    var leaving = false;

    // Arrival: the head script flagged html.sarte-pt-pending before first paint → lift the panels
    var came = html.classList.contains('sarte-pt-pending');
    var preloaderActive = !!$('[data-sarte-preloader]') && b.classList.contains('sarte-loading');
    if (came && !preloaderActive) {
      pt.classList.add('is-out');
      b.classList.add('sarte-pt-enter');
      html.classList.remove('sarte-pt-pending');
      setTimeout(function () {
        pt.classList.add('is-leaving');
        setTimeout(function () {
          // reset silently: panels jump back below the viewport without animating through it
          pt.classList.add('is-reset'); void pt.offsetWidth;
          pt.classList.remove('is-out', 'is-leaving');
          b.classList.remove('sarte-pt-enter');
          setTimeout(function () { pt.classList.remove('is-reset'); }, 60);
        }, 800);
      }, 120);
    } else {
      html.classList.remove('sarte-pt-pending');
    }

    d.addEventListener('click', function (e) {
      if (leaving) return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:|sms:|whatsapp:)/i.test(href)) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      if (/\/(cart|checkout|account\/logout|admin)/.test(url.pathname) && url.pathname !== '/cart') return;
      if (/\/cart\/(add|change|update|clear)/.test(url.pathname)) return;
      if (a.closest('[data-quick-add-modal], .drawer, .cart-drawer, .modal')) return;
      e.preventDefault();
      leaving = true;
      try { sessionStorage.setItem('sarte_pt', '1'); } catch (err) {}
      pt.classList.add('is-in');
      setTimeout(function () { location.href = url.href; }, 560);
      // safety: if navigation is blocked (e.g. beforeunload), release
      setTimeout(function () { if (leaving) { pt.classList.add('is-reset'); void pt.offsetWidth; pt.classList.remove('is-in'); leaving = false; setTimeout(function () { pt.classList.remove('is-reset'); }, 60); } }, 4000);
    }, true);

    // Back/forward cache: make sure the curtain is not stuck
    w.addEventListener('pageshow', function (ev) { if (ev.persisted) { pt.classList.add('is-reset'); void pt.offsetWidth; pt.classList.remove('is-in', 'is-out', 'is-leaving'); html.classList.remove('sarte-pt-pending'); leaving = false; setTimeout(function () { pt.classList.remove('is-reset'); }, 60); } });
  }

  /* ---------- Scroll progress hairline ---------- */
  function initProgress() {
    var bar = $('[data-sarte-progress]');
    if (!bar) return;
    var ticking = false;
    function update() {
      ticking = false;
      var max = (d.documentElement.scrollHeight - w.innerHeight) || 1;
      var p = Math.min(1, Math.max(0, (w.scrollY || d.documentElement.scrollTop) / max));
      bar.style.setProperty('--sp', p.toFixed(4));
    }
    w.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    w.addEventListener('resize', update);
    update();
  }

  /* ---------- Badge bump when a count changes ---------- */
  function initBadges() {
    $$('.header-cart-count, .header-wishlist-count').forEach(function (el) {
      var last = el.textContent.trim();
      new MutationObserver(function () {
        var now = el.textContent.trim();
        if (now === last) return;
        last = now;
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function initAll(scope) {
    initSwap(scope); initButtons(scope); initMagnetic(scope); initKickers(scope); initCardTilt(scope);
  }
  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  ready(function () { initAll(); initPageTransitions(); initProgress(); initBadges(); });
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  // product grids rendered later (quick add modal, predictive search, AJAX collections)
  var mo = new MutationObserver(function (muts) {
    var need = false;
    for (var i = 0; i < muts.length && !need; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && !n.classList.contains('sarte-ripple')) { need = true; break; }
      }
    }
    if (need) { clearTimeout(mo._t); mo._t = setTimeout(function () { initAll(); }, 120); }
  });
  ready(function () { mo.observe(b, { childList: true, subtree: true }); });
})();
